import { multiply, transpose } from "mathjs"
import firstOrderSolver from "./solver"
import geometricalStiffnerMatrix from "./geometricalStiffnerMatrix"
import geometricProps from "./geometricProps"
import localKMatrix from "./localKMatrix"
import rotationMatrix from "./rotationMatrix"

var kglocal = []

function globalKMatrix(barNodes, nNodes, barPropsArray, nBar, restrictedDisplacementVector, forceVector, isSecondOrder, distributedMagnitudeX, distributedMagnitudeY) {
    //console.log(barNodes)
    var kGlobal = []
    //Criando matriz de rigidez global com zeros:
    for(let i = 0; i < 3*nNodes; i++){
        kGlobal[i] = new Array(3*nNodes).fill(0)
    }

    //iterando por barra
    for (let i = 0; i < barNodes.length; i++){
        //propiedades geométricas e de material das barras:
        var EA = barPropsArray[i][0] * barPropsArray[i][2]
        var EI = barPropsArray[i][0] * barPropsArray[i][1]
        //geometria de cada barra
        var geometry = geometricProps(barNodes, i)
        //matriz de roração
        var beta = rotationMatrix(geometry.sn, geometry.cs)
        //matriz de rigidez local da barra
        var klocal = localKMatrix(geometry.L, EA, EI)
        //para matriz de segunda ordem
        if(isSecondOrder){
            console.log("segunda ordem")
            var firstOrder = firstOrderSolver(nNodes, nBar, barNodes, restrictedDisplacementVector, forceVector, barPropsArray, false, distributedMagnitudeX, distributedMagnitudeY)
            firstOrder = firstOrder.EIS

            //Trabalhar pegando os nós associados de cada barra
            var P = firstOrder[i]
            var kg = geometricalStiffnerMatrix(P, geometry.L, barPropsArray[i][1],barPropsArray[i][2])

            //fazer a adição manualmente            
            //klocal = add(klocal, kg)

            for(let j=0; j < 6; j++){
                for(let k=0; k < 6; k++){
                    klocal[j][k] = klocal[j][k] + kg[j][k]
                }
            }

            kglocal[i] = klocal

        }
        //rotacionando a matriz local para o UCS global
        var transposedKLocal = multiply(transpose(beta), klocal)
        transposedKLocal = multiply(transposedKLocal, beta)

        //atribuição dos nós nas barras:
        var j = barNodes[i][2]
        var k = barNodes[i][5]

        //montagem da matriz de rigidez global
        for (let l = 0; l < 3; l++){
            for (let m = 0; m < 3; m++){
                kGlobal[j*3+l][j*3+m] = transposedKLocal[l][m] + kGlobal[j*3+l][j*3+m]
                kGlobal[j*3+l][k*3+m] = transposedKLocal[l][m+3] + kGlobal[j*3+l][k*3+m]
                kGlobal[k*3+l][j*3+m] = transposedKLocal[l+3][m] + kGlobal[k*3+l][j*3+m]
                kGlobal[k*3+l][k*3+m] = transposedKLocal[l+3][m+3] + kGlobal[k*3+l][k*3+m]
            }
        }
    }
    
    return ({kGlobal, kglocal})
}

export default globalKMatrix